// @ts-nocheck - may need to be at the start of file
import * as React from 'react';
import {
  AppBar,
  Logout,
  UserMenu,
  useTranslate,
  useLocaleState,
  useUserMenu,
} from 'react-admin';
import { Link } from 'react-router-dom';
import {
  Box,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  Theme,
  Menu,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

import Logo from './Logo';
import { forwardRef } from 'react';
import Language from '@mui/icons-material/Language';

const SwitchLanguage = forwardRef((props, ref) => {
  const [locale, setLocale] = useLocaleState();
  const { onClose } = useUserMenu();

  return (
    <div>
      <MenuItem
        ref={ref}
        {...props}
        sx={{ color: 'text.secondary' }}
        onClick={(event) => {
          setLocale(locale === 'en' ? 'fr' : 'en');
          onClose();
        }}
      >
        <ListItemIcon sx={{ minWidth: 5 }}>
          <Language />
        </ListItemIcon>
        english
      </MenuItem>

      <MenuItem
        ref={ref}
        {...props}
        sx={{ color: 'text.secondary' }}
        onClick={(event) => {
          setLocale('sv');
          onClose();
        }}
      >
        <ListItemIcon sx={{ minWidth: 5 }}>
          <Language />
        </ListItemIcon>
        Swedish
      </MenuItem>
    </div>
  );
});

const ConfigurationMenu = React.forwardRef((props, ref) => {
  const translate = useTranslate();
  return (
    <MenuItem
      component={Link}
      // @ts-ignore
      ref={ref}
      {...props}
      to='/configuration'
    >
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText>{translate('pos.configuration')}</ListItemText>
    </MenuItem>
  );
});
const CustomUserMenu = () => (
  <UserMenu>
    <ConfigurationMenu />
    <SwitchLanguage />
    <Logout />
  </UserMenu>
);

const CustomAppBar = (props: any) => {
  const isLargeEnough = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up('sm')
  );
  return (
    <AppBar
      {...props}
      color='secondary'
      elevation={1}
      userMenu={<CustomUserMenu />}
    >
      <Typography
        variant='h6'
        color='inherit'
        sx={{
          flex: 1,
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
        id='react-admin-title'
      />
      {isLargeEnough && <Logo />}
      {isLargeEnough && <Box component='span' sx={{ flex: 1 }} />}
    </AppBar>
  );
};

export default CustomAppBar;
